import React, { useState, useEffect } from 'react';
import proptypes from 'prop-types';
const {
  string, func, bool, element, shape, oneOf
} = proptypes;
import { Button } from '@one-thd/sui-atomic-components';
import { SwapDrawer } from './sub-components/swap-drawer/SwapDrawer';
import { dataModel } from './sub-components/swap-drawer/dataModel';
import { DRAWER_FLOWS } from '../constants/drawerFlows';

const SwapItem = ({
  itemId,
  onSwap,
  closeOnSwap,
  className,
  promoId,
  disabled,
  hideIcon,
  isDark,
  btnContent,
  customElement,
  selectionButtonContent,
  hideCurrentSelectedItem,
  currentItemSelectable,
  isSmall,
  openInQuickViewDescription,
  openDetailsInNewTab,
  hideQuickViewMask,
  itemIndex,
  drawerRootProps,
  openCurrentItemInQuickView,
  filterResponse,
  flow
}) => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('swap-item.ready');
  }, []);
  const [openSwapDrawer, setOpenSwapDrawer] = useState(false);
  const [fetch, setFetch] = useState(false);

  const handleMouseEnter = (event) => {
    event.preventDefault();
    if (!disabled) {
      setFetch(true);
    }
  };

  const handleClick = (event) => {
    event.preventDefault();
    setOpenSwapDrawer(true);
    handleMouseEnter(event);
  };

  const handleSwap = (product) => {
    onSwap(product);
    if (closeOnSwap) {
      setOpenSwapDrawer(false);
    }
  };

  return (
    <div className={className} data-testid="swap-item" data-component="SwapItem">
      {customElement ? (
        <div
          onClick={handleClick}
          role="button"
          tabIndex="0"
          onMouseEnter={handleMouseEnter}
        >
          {customElement}
        </div>
      ) : (
        <Button
          variant={isDark ? 'primary' : 'secondary'}
          onClick={handleClick}
          onMouseEnter={handleMouseEnter}
          disabled={disabled}
        >
          {!hideIcon && (
            <img
              src="https://assets.thdstatic.com/images/v1/swap-icon.svg"
              alt="Swap Item"
              className="sui-mr-[10px]"
            />
          )}
          {btnContent}
        </Button>
      )}
      <SwapDrawer
        openSwapDrawer={openSwapDrawer}
        itemId={itemId}
        fetch={fetch}
        onClose={() => {
          setOpenSwapDrawer(false);
        }}
        onSwap={handleSwap}
        promoId={promoId}
        hideCurrentSelectedItem={hideCurrentSelectedItem}
        selectionButtonContent={selectionButtonContent}
        currentItemSelectable={currentItemSelectable}
        openInQuickViewDescription={openInQuickViewDescription}
        openDetailsInNewTab={openDetailsInNewTab}
        hideQuickViewMask={hideQuickViewMask}
        itemIndex={itemIndex}
        drawerRootProps={drawerRootProps}
        openCurrentItemInQuickView={openCurrentItemInQuickView}
        filterResponse={filterResponse}
        flow={flow}
      />
    </div>
  );
};

SwapItem.propTypes = {
  itemId: string.isRequired,
  onSwap: func.isRequired,
  promoId: string,
  className: string,
  disabled: bool,
  closeOnSwap: bool,
  hideIcon: bool,
  isDark: bool,
  btnContent: string,
  customElement: element,
  hideCurrentSelectedItem: bool,
  selectionButtonContent: string,
  isSmall: bool,
  currentItemSelectable: bool,
  openInQuickViewDescription: bool,
  openDetailsInNewTab: bool,
  hideQuickViewMask: bool,
  itemIndex: string,
  drawerRootProps: shape({}),
  openCurrentItemInQuickView: bool,
  filterResponse: bool,
  flow: oneOf(Object.values(DRAWER_FLOWS))
};

SwapItem.defaultProps = {
  className: '',
  promoId: null,
  disabled: false,
  closeOnSwap: false,
  hideIcon: false,
  isDark: true,
  btnContent: 'Swap Model',
  customElement: null,
  hideCurrentSelectedItem: false,
  selectionButtonContent: null,
  isSmall: false,
  currentItemSelectable: false,
  openInQuickViewDescription: false,
  openDetailsInNewTab: false,
  hideQuickViewMask: false,
  itemIndex: 'n/a',
  drawerRootProps: {},
  openCurrentItemInQuickView: false,
  filterResponse: true,
  flow: DRAWER_FLOWS.DEFAULT
};

SwapItem.displayName = 'SwapItem';

SwapItem.dataModel = dataModel;

export { SwapItem };
